import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × ALAIN MIKLI: Optical eyewear meets optical art
// Lens symmetry, checker reflections, prismatic grids
export function VasarelyAlainmikliMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="mikli-lens1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FF6B35" />
          <stop offset="50%" stopColor="#FF8C42" />
          <stop offset="100%" stopColor="#FFAA4F" />
        </linearGradient>
        <linearGradient id="mikli-lens2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#4A90E2" />
          <stop offset="50%" stopColor="#5FA3E8" />
          <stop offset="100%" stopColor="#74B6EE" />
        </linearGradient>
        <radialGradient id="mikli-reflection">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Clean optical background */}
      <rect x="0" y="0" width="794" height="1123" fill="#F0F0F0" />

      <g transform="translate(397 540)">
        {/* Checker reflections */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 22 }).map((_, j) => {
            const x = (i - 7.5) * 48;
            const y = (j - 10.5) * 48;
            const isBlack = (i + j) % 2 === 0;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 22}
                y={y - 22}
                width="44"
                height="44"
                fill={isBlack ? "#333333" : "#DDDDDD"}
                opacity="0.08"
              />
            );
          })
        )}

        {/* Prismatic grids */}
        {Array.from({ length: 12 }).map((_, i) => {
          const angle = (i * Math.PI) / 6;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 300}
              y2={Math.sin(angle) * 300}
              stroke={i % 3 === 0 ? "#FF6B35" : i % 3 === 1 ? "#4A90E2" : "#9B59B6"}
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Lens symmetry (left and right) */}
        {[-120, 120].map((xOffset, idx) => (
          <g key={idx}>
            <circle
              cx={xOffset}
              cy="0"
              r="90"
              fill={idx === 0 ? "url(#mikli-lens1)" : "url(#mikli-lens2)"}
              opacity="0.15"
            />
            <circle
              cx={xOffset}
              cy="0"
              r="90"
              fill="none"
              stroke={idx === 0 ? "#FF6B35" : "#4A90E2"}
              strokeWidth="3"
              opacity="0.5"
            />
            <circle
              cx={xOffset}
              cy="0"
              r="80"
              fill="none"
              stroke={idx === 0 ? "#FF8C42" : "#5FA3E8"}
              strokeWidth="2"
              opacity="0.4"
            />
            
            {/* Reflection effect */}
            <circle
              cx={xOffset - 20}
              cy="-20"
              r="25"
              fill="url(#mikli-reflection)"
            />
            
            {/* Inner optical patterns */}
            {Array.from({ length: 6 }).map((_, i) => {
              const r = 20 + i * 10;
              return (
                <circle
                  key={i}
                  cx={xOffset}
                  cy="0"
                  r={r}
                  fill="none"
                  stroke={idx === 0 ? "#FFAA4F" : "#74B6EE"}
                  strokeWidth="0.5"
                  opacity={0.3 - i * 0.04}
                />
              );
            })}
          </g>
        ))}

        {/* Bridge connection */}
        <rect
          x="-30"
          y="-10"
          width="60"
          height="20"
          fill="#333333"
          opacity="0.3"
          rx="5"
        />

        {/* Recursive precision circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 240 + i * 15;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#666666"
              strokeWidth="1"
              opacity={0.15 - i * 0.012}
            />
          );
        })}

        {/* Frame outline */}
        <ellipse
          cx="-120"
          cy="0"
          rx="100"
          ry="95"
          fill="none"
          stroke="#333333"
          strokeWidth="4"
          opacity="0.2"
        />
        <ellipse
          cx="120"
          cy="0"
          rx="100"
          ry="95"
          fill="none"
          stroke="#333333"
          strokeWidth="4"
          opacity="0.2"
        />
      </g>

      {/* Vision identity */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#333333" fontWeight="600" letterSpacing="3">
        RECURSIVE VISION
      </text>
    </g>
  );
}
